module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a80790c977586cc0595b5fe2f0bcb39a.svg";